import { PolygonsActions } from './polygonsActions';

const initialState = {
  switches: {
    idSelected: '',
    toEdit: {
      name: '',
      id: '',
    },
    toDelete: {
      name: '',
      id: '',
    },
  },
  onlyOwnPolygons: false,
  isLoadingPolygons: false,
  refetch: false,
  draw: {
    type: 'none',
    radius: null,
    coords: null,
    center: null,
    isActive: false,
  },
};

interface PolygonsReducerParams {
  type: string;
  payload: any;
}

export default function polygonsReducer(
  state = initialState,
  { type, payload }: PolygonsReducerParams
) {
  switch (type) {
    case PolygonsActions.REFETCH_DATA:
      return { ...state, refetch: !state.refetch };
    case PolygonsActions.DISPLAY_OWN_POLYGONS:
      return { ...state, onlyOwnPolygons: payload };
    case PolygonsActions.SET_IS_LOADING_POLYGONS:
      return { ...state, isLoadingPolygons: payload };
    case PolygonsActions.SET_SELECTED_SWITCH:
      return { ...state, switches: { ...state.switches, idSelected: payload } };
    case PolygonsActions.SET_NAME_AND_ID_TO_EDIT:
      return {
        ...state,
        switches: {
          ...state.switches,
          toEdit: { name: payload.name, id: payload.id },
        },
      };
    case PolygonsActions.SET_NAME_AND_ID_TO_DELETE:
      return {
        ...state,
        switches: {
          ...state.switches,
          toDelete: { name: payload.name, id: payload.id },
        },
      };
    case PolygonsActions.UPDATE_DRAW_STATE: {
      return {
        ...state,
        draw: payload,
      };
    }
    default:
      return state;
  }
}
